import { RefObject } from 'react';
import globalConfig from '../config/config';
import Urls from './baseUrls';

const DEFAULT_BORDER_COLOR = '#ced4da';

/**
 * to fetch the react app path
 * @param src route
 * @returns
 */
export const prefixPath = (src: string): string => {
    if (process.env.REACT_APP_SUB_PATH !== '' && process.env.REACT_APP_SUB_PATH !== undefined) {
        return process.env.REACT_APP_SUB_PATH + src;
    }
    return src;
};

/**
 * to copy content.source to clipboard
 * @param src source that to be copied
 * @returns void
 */
export const copyToClipboard = (src: string): void => {
    if (navigator) navigator.clipboard.writeText(src);
};

/**
 * To add border color the the HTML element
 * @param ref
 * @param color
 * @returns void
 */
export const addBorderColor = (ref: RefObject<HTMLElement>, color?: string): void => {
    if (ref.current) {
        if (!color) color = DEFAULT_BORDER_COLOR;
        ref.current.style.borderColor = color;
    }
};

/**
 * To remove border color from the HTML element on timeout
 * @param ref
 * @param ms
 * @param color
 * @returns void
 */
export const removeBorderColorOnTimeout = (ref: RefObject<HTMLElement>, ms: number, color?: string): void => {
    setTimeout(() => {
        if (ref.current) {
            const _clr = color ? color : DEFAULT_BORDER_COLOR;
            ref.current.style.borderColor = _clr;
        }
    }, ms);
};

/**
 * To remove content of the HTML element on timeout
 * @param ref
 * @param ms
 * @returns void
 */
export const removeHTMLContentOnTimeout = (ref: RefObject<HTMLElement>, ms: number): void => {
    setTimeout(() => {
        if (ref.current) {
            ref.current.innerHTML = '';
        }
    }, ms);
};

/**
 * To get cloud details from the config file
 * @param val Cloud ID
 * @returns
 */
export const getCloudById = (val: string | number) => {
    const config = globalConfig.getConfig;

    if (config) {
        return config.clouds[val];
    }

    return '';
};

/**
 * To get Infra details from the config file
 * @param key Infra key
 * @returns
 */
export const getInfraDetails = (key: string): { cloudId: string; managedHosting: boolean } | string => {
    const config = globalConfig.getConfig;

    if (config) {
        const { infraTypes } = config;
        return infraTypes[key];
    }
    return '';
};

// Generate random Id
export const makeid = (length: number) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i += 1) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

/**
 * To get Breadcrumb Path
 * @param src value of 'from' key of local storage
 * @returns [{ name: string; path: string }]
 */
export const breadcrumbPath = (src: string): { name: string; path: string }[] => {
    const path_one = localStorage.getItem('workspaceName') || '';

    const path_url = localStorage.getItem('workspace_url') || '';

    let path: { name: string; path: string }[] = [];

    if (src === 'fullnode') {
        path = [
            { name: 'Dashboard', path: Urls.getPlatformDashboardUrl() },
            { name: 'Dedicated Full Nodes', path: Urls.getPlatformManageDedicatedNodesUrl() },
        ];
    } else if (src === 'validatornode') {
        path = [
            { name: 'Dashboard', path: Urls.getPlatformDashboardUrl() },
            { name: 'Dedicated Validator Nodes', path: Urls.getPlatformManageStakingNodesUrl() },
        ];
    } else if (src === 'workspace') {
        path = [
            { name: 'Dashboard', path: Urls.getPlatformDashboardUrl() },
            { name: 'Workspaces', path: Urls.getPlatformWorkspaceUrl() },
            { name: path_one, path: Urls.getPlatformWorkspaceUrl() + `/${path_url}` },
        ];
    }

    return path;
};